import { render, staticRenderFns } from "./SignatureEditor.vue?vue&type=template&id=c106f8b8&scoped=true&"
import script from "./SignatureEditor.vue?vue&type=script&lang=js&"
export * from "./SignatureEditor.vue?vue&type=script&lang=js&"
import style0 from "./SignatureEditor.vue?vue&type=style&index=0&id=c106f8b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c106f8b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VBtn,VIcon,VInput})
